{
  "pages": [
    {
      "guideType": "docs",
      "slug": "maps",
      "canonicalPath": "/docs/maps",
      "title": "Maps & Place Guides",
      "description": "Find places, read sourced guides, and plan an outing in Chat.",
      "badge": "Features",
      "badgeColor": "#3B82F6",
      "navSectionSlug": "features",
      "navOrder": 45,
      "navIcon": "map",
      "searchKeywords": [
        "maps",
        "places",
        "location",
        "restaurants",
        "coffee",
        "hours",
        "itinerary",
        "outing",
        "guide"
      ],
      "meta": {
        "title": "Maps & Place Guides | Gab AI Docs",
        "description": "Find places, read sourced guides, and plan an outing in Chat.",
        "keywords": "maps, places, location, restaurants, coffee, hours, itinerary, outing, guide",
        "pageCopy": [
          {
            "type": "section",
            "title": "Find places in an area",
            "copy": "Open Maps from the main navigation and sign in to search. Enter a city, neighborhood, or address, then describe what you want to find or choose a category. Results appear on a map and in photo cards. Select a result or map pin to open its details."
          },
          {
            "type": "section",
            "title": "Use your location on the web",
            "copy": "Choose Use my location if you want to search around your device. Your browser asks for location permission. If it cannot obtain a position or times out, Gab AI may use your network’s approximate area and labels it clearly. If you deny location permission, enter an area yourself. Choose Stop using my location to clear it. In the native apps, use the city or address field."
          },
          {
            "type": "section",
            "title": "Read a place guide",
            "copy": "Open a place to see available photos, ratings, opening hours, address, phone, website, and map links. The detail panel appears beside the map on wider screens or as a sheet on smaller screens. Its AI guide organizes available evidence into useful sections such as reviews, what to order, atmosphere, highlights, and visit tips, with source links. Missing information is not a guarantee that a service or amenity is unavailable."
          },
          {
            "type": "section",
            "title": "Copy, share, or download a guide",
            "copy": "Use the response actions below a completed guide to copy it, share it, or download it as text. On the web, Share offers Copy guide, Email guide, and Share to apps when the browser supports it. Native clients use their system share controls. Source links are included with the guide."
          },
          {
            "type": "section",
            "title": "Plan an outing",
            "copy": "Choose Plan an outing above the results map. Gab AI opens a Chat draft in Auto mode containing the actual places and links from your search. Review it, add your date, available time, transport, or accessibility needs, and send it. The request asks for an interactive itinerary with practical stops, suggested times, travel estimates, and map/source links. It does not book a table, buy tickets, or create reservations."
          },
          {
            "type": "section",
            "title": "Check before you travel",
            "copy": "Opening hours, availability, ratings, and AI summaries can be incomplete or change. Check the linked business or venue before relying on them. Approximate location is not your exact position. If search or a guide fails, retry or use the available map/website link; you can always change the area manually."
          },
          {
            "type": "quick-links",
            "items": [
              {
                "title": "Interactive answer cards",
                "label": "Interactive answer cards",
                "href": "/docs/interactive-cards"
              },
              {
                "title": "Chat",
                "label": "Chat",
                "href": "/docs/chat"
              }
            ]
          }
        ]
      },
      "navigation": {}
    },
    {
      "guideType": "docs",
      "slug": "interactive-cards",
      "canonicalPath": "/docs/interactive-cards",
      "title": "Interactive Answer Cards",
      "description": "Use Chat plans, checklists, comparisons, itineraries, and study cards.",
      "badge": "Features",
      "badgeColor": "#3B82F6",
      "navSectionSlug": "features",
      "navOrder": 46,
      "navIcon": "list-check",
      "searchKeywords": [
        "cards",
        "checklist",
        "meal plan",
        "itinerary",
        "comparison",
        "study",
        "quiz",
        "event",
        "bookmark",
        "progress"
      ],
      "meta": {
        "title": "Interactive Answer Cards | Gab AI Docs",
        "description": "Use Chat plans, checklists, comparisons, itineraries, and study cards.",
        "keywords": "cards, checklist, meal plan, itinerary, comparison, study, quiz, event, bookmark, progress",
        "pageCopy": [
          {
            "type": "section",
            "title": "Ask for a usable plan",
            "copy": "Chat can turn a request into an interactive answer card. Supported types include meal plans, checklists, itineraries, comparisons, study plans, project guides, and event plans. Recipes have their own card. Ask for a specific result, such as a three-day meal plan with a grocery list or a half-day walking itinerary."
          },
          {
            "type": "section",
            "title": "Use the controls on the card",
            "copy": "Controls depend on the answer: check off tasks or supplies, inspect comparison criteria, switch between plan sections, open place/source links, or answer a study quiz. Some meal plans include recipe details. A card is an answer in the conversation; ask for revisions in Chat if the plan needs to change."
          },
          {
            "type": "section",
            "title": "Understand saved progress",
            "copy": "Where a card has checkboxes, its completion count reflects your selections, not work verified by the AI. Eligible private-chat progress is saved on the current device. The card says whether progress is saved, kept only while open, or could not be saved. Do not expect progress to synchronize between devices or public/shared views. Changed instructions can require checking an item again."
          },
          {
            "type": "section",
            "title": "Bookmark or save an image",
            "copy": "Bookmark saves the containing message when you own the conversation; find it later in Bookmarks. The image action captures the card for downloading or sharing through the available device controls. Check the exported result before using it. An image export is not an editable spreadsheet, document, or calendar event."
          },
          {
            "type": "section",
            "title": "Choose Work for an editable deliverable",
            "copy": "If you need a workbook with formulas, a document, presentation, code project, or another downloadable file, select Work and describe that deliverable. Work requires Plus and consumes credits. A Chat card can help you decide what to request, but it does not automatically create a Work file or perform a reservation or other external action."
          },
          {
            "type": "quick-links",
            "items": [
              {
                "title": "Maps & Place Guides",
                "label": "Maps & Place Guides",
                "href": "/docs/maps"
              },
              {
                "title": "Bookmarks",
                "label": "Bookmarks",
                "href": "/docs/bookmarks"
              },
              {
                "title": "Work artifacts",
                "label": "Work artifacts",
                "href": "/docs/work-artifacts"
              }
            ]
          }
        ]
      },
      "navigation": {}
    },
    {
      "guideType": "docs",
      "slug": "plugins",
      "canonicalPath": "/docs/plugins",
      "title": "Plugins & Connected Accounts",
      "description": "Add skills, approved service connections, and supported MCP servers to Work on Mac.",
      "badge": "Features",
      "badgeColor": "#3B82F6",
      "navSectionSlug": "features",
      "navOrder": 47,
      "navIcon": "puzzle-piece",
      "searchKeywords": [
        "plugins",
        "skills",
        "connections",
        "accounts",
        "mcp",
        "oauth",
        "mac",
        "tools"
      ],
      "meta": {
        "title": "Plugins & Connected Accounts | Gab AI Docs",
        "description": "Add skills, approved service connections, and supported MCP servers to Work on Mac.",
        "keywords": "plugins, skills, connections, accounts, mcp, oauth, mac, tools",
        "pageCopy": [
          {
            "type": "section",
            "title": "Open Plugins on Mac",
            "copy": "On a compatible Gab AI Mac build, open Settings → Plugins. This Settings section is available on Mac; web, iOS, and Android do not offer it. Work requires Plus. If a feature is missing, check the installed Mac version and the message shown by the app."
          },
          {
            "type": "section",
            "title": "Install a skill or workflow",
            "copy": "Browse the catalog, inspect a package, and install it. Portable skill packages add reusable instructions for work such as research, writing, meeting notes, or spreadsheet review. A package labeled (Browser) needs approved browser access on the Mac. Installation by itself does not authorize files, apps, websites, or accounts."
          },
          {
            "type": "section",
            "title": "Connect a supported account",
            "copy": "Where a catalog package offers Connect, choose it, finish the provider’s authorization in your browser, and return to check the connection status before choosing Use in Work. Providers such as Gmail, Google Drive, Google Calendar, GitHub, GitLab, Notion, Slack, and TradingView depend on server configuration and your eligibility. Available actions depend on the service and the permissions you approved. A browser workflow and a connected-account package are different ways of reaching a service."
          },
          {
            "type": "section",
            "title": "Add a custom MCP server",
            "copy": "Choose Add MCP server, enter a server name and its public HTTPS Streamable HTTP MCP URL, and choose Connect server. Leave the token blank for automatic connection or browser sign-in. Complete two-factor authentication on the provider’s sign-in page. You can also enter a server-issued access token, or use Advanced OAuth settings when a provider requires a registered client ID. Credentials are encrypted in your Gab AI account. If connections are unavailable, contact support or refresh availability. Tool inputs are shared with the server when used, so add a server only if you trust it."
          },
          {
            "type": "section",
            "title": "Supported connection limits",
            "copy": "Custom browser sign-in requires compatible OAuth discovery and secure authorization-code support. Provider app approval, subscriptions, and account permissions still apply. The custom form does not support local commands, localhost or private-network servers, arbitrary headers, URL credentials, or legacy SSE-only endpoints. Server availability and tool discovery do not guarantee that every action will succeed; Work action approvals still apply."
          },
          {
            "type": "section",
            "title": "Update, disable, or disconnect",
            "copy": "You can update, disable, or remove a package and disconnect an account in Settings. New Work tasks use the selected instruction snapshot. Existing tasks keep their original instructions, while service calls still require a valid connection. Disconnecting stops subsequent service access; it cannot undo an action already accepted by the provider. Folder, browser, and app permissions are managed separately."
          },
          {
            "type": "quick-links",
            "items": [
              {
                "title": "Work overview",
                "label": "Work overview",
                "href": "/docs/work"
              },
              {
                "title": "Browser & app access",
                "label": "Browser & app access",
                "href": "/docs/mac-browser-access"
              },
              {
                "title": "Project folders",
                "label": "Project folders",
                "href": "/docs/project-folders"
              }
            ]
          }
        ]
      },
      "navigation": {}
    }
  ]
}
